<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VCXRyT/tc-custom/9783956760136_IMGJPG_FrontCover_0.jpg" alt="This image is the cover for the book A Pipe Of Mystery, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Pipe Of Mystery, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>An Indian ghost story: "I landed in India in '50, and after going through the regular drill work marched with a detachment up country to join my regiment, which was stationed at Jubbalpore, in the very heart of India. It has become an important place since; the railroad across India passes through it and no end of changes have taken place; but at that time it was one of the most out of the way stations in India, and, I may say, one of the most pleasant. It lay high, there was capital boating on the Nerbudda, and, above all, it was a grand place for sport, for it lay at the foot of the hill country, an immense district, then but little known, covered with forests and jungle, and abounding with big game of all kinds...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        G. A. Henty
      </h2>
      
      <p class="authorDescription body article">George Alfred Henty (8 December 1832 – 16 November 1902) was a prolific English novelist and war correspondent. He is best known for his historical adventure stories that were popular in the late 19th century. His works include The Dragon & The Raven (1886), For The Temple (1888), Under Drake's Flag (1883) and In Freedom's Cause (1885). (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3741eee0